import { Component, inject, OnInit, signal } from '@angular/core';
import { IonContent, IonHeader, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { WorkNews, WorkWebsiteArticlesAndBannersV2Service } from '@work-frontend-monorepo/work-rest-api';
import { lastValueFrom } from 'rxjs';
import { LoggerService } from '@work-frontend-monorepo/work-ui/services';
import { TranslatePipe } from '@ngx-translate/core';
import { MitteilungenCardComponent } from '../../../features/mitteilungen/components/mitteilungen-card/mitteilungen-card.component';

@Component({
  selector: 'sfg-app-global-start-news-tab',
  templateUrl: './global-start-news-tab.component.html',
  standalone: true,
  imports: [IonContent, IonHeader, IonTitle, IonToolbar, MitteilungenCardComponent, TranslatePipe],
})
export class GlobalStartNewsTabComponent implements OnInit {
  private readonly workWebsiteArticlesAndBannersV2Service = inject(WorkWebsiteArticlesAndBannersV2Service);

  news = signal<WorkNews[]>([]);

  async ngOnInit() {
    try {
      const news = await lastValueFrom(
        this.workWebsiteArticlesAndBannersV2Service.websiteArticlesAndBannersV2ControllerFindArticlesPaginated(),
      );
      if (news && news.data) {
        this.news.set(news.data);
      }
    } catch (loadNewsException) {
      LoggerService.ERROR(this, 'loadNewsException', loadNewsException);
    }
  }
}
